"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TileBase_styles_1 = require("../TileBase/TileBase.styles");
var TileButtonsAndFooter_1 = require("../TileBase/TileButtonsAndFooter");
var PagedTabArticleButtonsAndFooter = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(TileBase_styles_1.Article, { AlignContent: props.Loading ? "center" : props.AlignContent ? props.AlignContent : "start", NoPadding: props.NoContentPadding }, props.children),
        React.createElement(TileButtonsAndFooter_1.default, { OnNextPage: props.OnNextPage, OnPreviousPage: props.OnPreviousPage, CurrentPage: props.CurrentPage, TotalPages: props.TotalPages, GoToButton: props.GoToButton, OptionsButton: props.OptionsButton, ItemId: props.ItemId, ItemTypeName: props.ItemTypeName, Loading: props.Loading, TileButtons: props.TileButtons })));
};
exports.default = PagedTabArticleButtonsAndFooter;
